import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SystemUserModel, Privilege } from "../models/SystemUserModel";
import { RoleEnum, UserRulesDisplayNames } from "../models/RoleModel";
import { ControlUserService } from "../services/control-user.service";
import { Globals } from "../globals";
import { ConfigClass } from "../config";

@Component({
  selector: "app-users-modal",
  templateUrl: "./users-modal.component.html",
  styleUrls: ["./users-modal.component.css"]
})
export class UsersModalComponent implements OnInit {
  userObj: SystemUserModel = {};
  privileges: Privilege[] = [];
  allowUpdate = false;
  role: any = {
    id: "",
    name: []
  };
  roles = [
    { name: RoleEnum.CUSTOMER_SERVICES, displayName: UserRulesDisplayNames.CUSTOMER_SERVICES },
    { name: RoleEnum.ADMIN, displayName: UserRulesDisplayNames.ADMIN },
    { name: RoleEnum.SECURITY, displayName: UserRulesDisplayNames.SECURITY },
    { name: RoleEnum.SECURITY_MANAGER, displayName: UserRulesDisplayNames.SECURITY_MANAGER }
  ];

  constructor(
    public dialogRef: MatDialogRef<UsersModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: ControlUserService,
    public globals: Globals
  ) {
    if (data && data.user) {
      this.userObj = data.user;
      this.userObj.registeredDate = this.globals.formateDate(this.userObj.registeredDate);
      this.userObj.roles.map(item => {
        this.role.name.push(item.name);
      })
      this.allowUpdate = data.allowUpdate;
      this.userObj.isEnabled = this.userObj.enabled ? "YES" : "NO";
    }
  }

  ngOnInit() {
    this.onRoleChanged("");
  }

  onRoleChanged(evt) {
    var adminIndex = this.role.name.findIndex((x) => x === RoleEnum.ADMIN);
    if (adminIndex > -1) {
      this.privileges = this.globals.getUserPrivilages();
      this.getAllPrivileges();
    }
    else {
      this.privileges = [];
    }
  }

  getAllPrivileges() {
    if (this.userObj.privileges && this.privileges) {
      this.userObj.privileges.forEach(elemnt => {
        this.privileges.forEach(privilege => {
          if (elemnt.name == privilege.name) {
            privilege.checked = true;
          }
        });
      });
    }
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  onClickSave(): void {
    var adminIndex = this.role.name.findIndex((x) => x === RoleEnum.ADMIN);
    var userAdminIndex = this.userObj.roles.findIndex((x) => x.name === RoleEnum.ADMIN);

    if (
      this.userObj.firstname &&
      this.userObj.lastname &&
      this.userObj.mobile &&
      this.userObj.email
    )
      if (this.allowUpdate) {
        if (
          ConfigClass.getPrivilageStatus == false ||
          adminIndex < 0 ||
          (adminIndex > -1 &&
            userAdminIndex > -1)
        ) {
          this.userObj.roles = [];
          this.role.name.map(item => {
            this.userObj.roles.push({ name: item });
          });

          //privileges
          this.userObj.privileges = [];
          this.privileges.forEach(privilege => {
            if (privilege.checked === true && !privilege.isHidden) {
              this.userObj.privileges.push({ name: privilege.name });
            }
          });

          this.userService
            .UpdateUser(this.userObj.id, this.userObj)
            .subscribe(a => {
              this.dialogRef.close(true);
              this.globals.presentSuccessToast("User has been updated successfully");
            });
        } else {
          this.globals.presentErrorToast("Can't change Role to Admin");
        }
      }
  }
}
